export const MONTHS = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];

export function formatCurrency(input: number) {
    return "$" + (input).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
}

export function formatDate(input: Date | string) {
    const date = new Date(input);
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
}

export function formatString(input: string) {
    const map: Record<string, string> = {
        '&': '&amp;',
        '<': '&lt;',
        '>': '&gt;',
        '"': '&quot;',
        "'": '&#39;',
        '/': '&#x2F;',
        '`': '&#x60;',
        '=': '&#x3D;'
    };

    return String(input).replace(/[&<>"'`=\/]/g, function (match) {
        return map[match];
    });
}

export function showDateSelector(options: { year?: { max: number; start: number; selected: number; }, month?: { selected: number; }; callBack: string; }) {
    let myf = '';
    if (options.year) {
        myf += `<label for="year">Select Year</label>`;
        myf += `<select onchange="${options.callBack}()" name="year" id="year-input" class="form-control">`;
        for (let i = options.year.max; i >= options.year.start; i--) {
            let selected = i === options.year.selected;
            myf += `<option value="${i}" ${selected ? 'selected' : ''}> ${i} </option>`;
        }
        myf += `</select>`;
    }

    if (options.month) {
        myf += `<label for="month">Select Month</label>`;
        myf += `<select onchange="${options.callBack}()" name="month" id="month-input" class="form-control">`;
        for (let i = 0; i < MONTHS.length; i++) {
            let selected = i === options.month.selected;
            myf += `<option value="${i}" ${selected ? 'selected' : ''}> ${MONTHS[i]} </option>`;
        }
        myf += `</select>`;
    }

    return myf;
}
